module.exports = __webpack_public_path__ + "media/images/redrock-winter-2020-hero-c54c290a43d55aaceaf8e9f7fe1aed11.jpg";